module.exports = __webpack_public_path__ + "static/media/Amazon_logo.b92bf065.svg";